// extracted by mini-css-extract-plugin
export var fb = "styles-module--fb--d4071";
export var footer = "styles-module--footer--a2167";
export var ig = "styles-module--ig--19a9f";
export var link = "styles-module--link--0de5e";
export var logo = "styles-module--logo--be6d4";
export var mc = "styles-module--mc--8d92a";
export var news = "styles-module--news--f9352";
export var sc = "styles-module--sc--08f84";
export var socialMedia = "styles-module--socialMedia--19f56";